module.exports = __webpack_public_path__ + "static/media/nasdaq.3decf04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/nasdaq.png
// module id = 1787
// module chunks = 146